import { Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../environments/environment";

@Component({
  selector: "error",
  templateUrl: "error.component.html"
})
export class ErrorComponent {
  private code = 500;
  private message = "Internal Server Error";
  private message403 = false;
  private messageOtherThan403 = false;
  private showHomeBtn = true;
  public ENV = environment;

  constructor(private router: Router, private route: ActivatedRoute) {
    this.route.params.subscribe((value: any) => {
      let errorType = value.type;
      switch (errorType) {
        case "not-authorised":
          this.code = 403;
          this.message403 = true;
          this.message = "";
          this.showHomeBtn = false;
          break;
        case "not-found":
          this.code = 404;
          this.messageOtherThan403 = true;
          this.message = "Page Not Found";
          this.showHomeBtn = true;
          break;
        case "internal-error":
          this.code = 500;
          this.messageOtherThan403 = true;
          this.message = "Internal Server Error";
          this.showHomeBtn = true;
          break;
        default:
          this.code = 500;
          this.messageOtherThan403 = true;
          this.message = "Internal Server Error";
          this.showHomeBtn = true;
          break;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/error/error.component.ts